import React, { Fragment } from 'react'
import { AiFeature } from '../../../../../../../models/AiFeature'
import { AiResult, StructuredSummaryResultType } from '../../../../../../../models/AiResult'
import { StructuredSummaryMeetingResultEditView } from './StructuredSummaryMeetingResultEditView'
import './EditableListMeetingResult.scss'
import { getSafeValueOnPath } from '../../../utils'

interface EditableListMeetingResultProps {
  aiFeature: AiFeature
  aiResult: AiResult
  basePath: string
  path: string
  onResultTextContentChange: (basePath: string, path: string, resultTextContent: string | boolean) => void
  onFormattedResultChange: (basePath: string, path: string, contentType: string, content: string) => void
}

export const EditableListMeetingResult: React.FC<EditableListMeetingResultProps> = ({
  aiResult,
  aiFeature,
  basePath,
  path,
  onResultTextContentChange,
  onFormattedResultChange,
}) => {
  const result = getSafeValueOnPath(getSafeValueOnPath(aiResult.result, basePath), path, ['']) ?? ['']
  const results: StructuredSummaryResultType[] = result.length === 0 ? [''] : result

  const hasObjectResult = results.some((result) => !Array.isArray(result) && typeof result === 'object')

  return (
    <div className='d-flex flex-column gap-1'>
      {results.map((_, idx) => {
        const childPath = `${path}[${idx}]`
        const lastChild = idx === results.length - 1
        return (
          <Fragment key={childPath}>
            <StructuredSummaryMeetingResultEditView
              aiFeature={aiFeature}
              aiResult={aiResult}
              basePath={basePath}
              path={childPath}
              onResultTextContentChange={onResultTextContentChange}
              onFormattedResultChange={onFormattedResultChange}
            />
            {!lastChild && hasObjectResult && <div className='editable-list-meeting-result-separator pt-2 pb-3' />}
          </Fragment>
        )
      })}
    </div>
  )
}
